<template>
	<div class="st-main-content">
		<div class="account-search-box">
			<div class="query-setting-box">
				<div class="query-setting-box-left">
					<div class="order-query-form-box">
						<label for="start-date">用户id：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.roleId"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">加盟物流名称：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.companyName"
								name="start-date"></span>
					</div>
					<!-- <div class="order-query-form-box">
						<label for="start-date">姓名：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.name"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">角色名称：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.account"
								name="start-date"></span>
					</div> -->
					<!-- <div class="order-query-form-box">
						<label for="start-date">公司名称：</label>
						<span class="order-query-form-input"><input type="text"  v-model="orderForm.roleId" name="start-date"></span>
					</div> -->
				</div>
				<div class="order-query-form-box-right">
					<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
				</div>
			</div>
		</div>

		<div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="togglePage"
				:loading="loading"

				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
				<template slot="contactSubject" slot-scope="scope">
                    <span>{{scope.row.contactSubject}}</span>
                </template>

				<template slot="state" slot-scope="scope">
					<span>{{scope.row.state?'是':'否'}}</span>
				</template>
			</common-table>
		</div>
		<st-dialog :title="dialogTitle" :toggleStDialog="toggleStDialog" @closeDialog="closeDialogForm" 
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content" style="width: 720px;">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">公司名称：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.name" ></div>
					</li>
					<li>
						<div class="st-dialog-item-title">用户昵称：</div>
						<div class="st-dialog-item-input"><input :disabled="editData.id" type="text" v-model="editData.logisticsUser.name"></div>
					</li>
					<!-- <li>
						<div class="st-dialog-item-title">手机号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.phone"></div>
					</li> -->
					<li>
						<div class="st-dialog-item-title">密码录入：</div>
						<div class="st-dialog-item-input"><input type="text" :disabled="editData.id" v-model="editData.logisticsUser.password"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">登录账号：</div>
						<div class="st-dialog-item-input"><input type="text" :disabled="editData.id" v-model="editData.logisticsUser.account"></div>
					</li>
				</ul>

				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">联系人：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactSubject"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">联系电话：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactPhone"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">付款方式：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="editData.paymentType" placeholder="请选择" size="small">
								<el-option v-for="item in paymentTypeList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul>
			<ul class="st-dialog-form clearfix">
					<li style="width: 250px;">
						<div class="st-dialog-item-title">省/市/区</div>
						<div class="st-dialog-item-input">
							<el-cascader class="ssq" size="small" :options="options" v-model="selectedOptions"
								@change="handleChange"
							>
							</el-cascader>
						</div>
					</li>
					<li style="width: 250px;">
						<div class="st-dialog-item-title">详细地址：</div>
						<div class="st-dialog-item-input">
						<!-- 	<! <input type="text" v-model="editData.shortAddress"> -->
						<el-select class="ssq" v-model="editData.shortAddress" filterable remote :remote-method="getNearAddress"
							:loading="loading" placeholder="请输入详细地址" size="small" @change="shortAddressChange">
								<el-option
									v-for="item in nearAddressArr"
									:key="item.title"
									:label="item.title"
									:value="{value:item.title,location:item.location,id:item.address}">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul> 
			</div>
		</st-dialog>
		
		<st-dialog :title="dialogTitle" :toggleStDialog="toggleStDialog2" @closeDialog="closeDialogForm"
			@saveDialog="saveDialogForm2">
			<div class="st-dialog-content" style="width: 720px;height:100px">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">充值金额：</div>
						<div class="st-dialog-item-input" style="position: absolute;top: 49px;left: 110px;"><input type="number" v-model="amountData.amount" ></div>
					</li>
				
				</ul>
			</div>
		</st-dialog>
		
	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'
	import { cityJson, CodeToText } from '@/assets/common/city.js'
	import { geoplace2, geoplace } from '@/utils/mapUtil.js'
	
	export default {
		name: 'JoinLogistics',
		props: [],
		components: { stDialog },
		data() {
			return {
				tableColumns:[
					{
						type: 'selection',
						fixed: 'left',
					},{
						key: '',
						title: '操作',
						operate:true,
						setBtns:(row,index)=>{
							return [
								{
									label:'编辑',
									handler: (row,index) => this.editUser(row)
								},
								{
									label:'充值',
									style:"color:#32BB57;marginRight:10px",
									handler: (row,index) => this.Recharge(row)
								},
								{
									label:row.valid == 1?'禁用':'恢复',
									style: row.valid == 1?"color:#32BB57;marginRight:10px":"marginRight:10px",
									handler: (row,index) => this.editCompany(row)
								}
							]
						}
					},{
						key: 'name',
						title: '公司名称',
					},{
						slotName:'contactSubject',
						slot:true,
						title: '联系人',
					},{
						key: 'contactPhone',
						title: '联系人电话',
					},{
						key: 'amount',
						title: '余额',
					}
				],
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
					layout: "total, sizes",
				},
				bottomHandleArr: [
					// {
					// 	label: '删除账号',
					// 	handler: () => this.deleteUser()
					// },
					{
						label: '新增账号',
						type: 'success',
						handler: () => this.addUser()
					},
				],


				nearAddressArr: [],
				loading: false,
				options: cityJson,
				selectedOptions: [],
				options2: [{
					value: '1',
					label: '是'
				}, {
					value: '2',
					label: '否'
				}],
				options3: [{
					value: 'SYSTEM',
					label: '系统用户'
				}, {
					value: 'FRANCHISE',
					label: '加盟公司'
				}],
				paymentTypeList: [{
					value: 'PROMPT_CASH',
					label: '寄付'
				}, {
					value: 'MONTHLY',
					label: '月结'
				}],
				roleTypeList: [
					{
						name: '超级管理员',
						id: 0
					},
					{
						name: '加盟公司',
						id: 1
					},
					{
						name: '管理员',
						id: 2
					},
				],
				value: '',
				value2: '',
				userId: null,
				currentEditData:{},
				editData: {
					genre: '系统用户',
					name:'',
					logisticsUser:{
						name:'',
						account:'',
						password:'',
					}
				},
				amountData:{
					 amount:'',
					 companyId:''
				},
				normalCheck: {
					name: '公司名必填',
					password: '登录密码必填',
					account: '登录账号必填'
				},
				amountCheck: {
					amount: '充值金额必填',
					
				},
				franshiseCheck: {
					provinceName: '省市区必填',
					shortAddress: '详细地址必填',
					contactPhone: '联系方式必填',
					contactSubject: '联系人或公司必填'
				},
				dataList: [],
				selectedList: [],
				orderForm: {
					account: null, //	登录账号	string	
					roleId: null, //	角色id	array<number>	
					name: null, //用户名
				},
				togglePage: false, //是否显示分页
				toggleStDialog: false,// 弹窗，
				toggleStDialog2:false,
				dialogTitle: '新增角色2',
				
			}
		},
		created() {

		},
		methods: {
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			shortAddressChange({value, location,id}) {
				this.editData.longitude = location.lng
				this.editData.latitude = location.lat
				this.editData.shortAddress = value
				this.editData.fullAddress = id
			},

			getNearAddress(e) {
				if (this.selectedOptions.length == 0) {
					return this.$toast.stMessage('请先选择省市区', 'warning')
				}
				this.loading = true;
				geoplace2(this, e, CodeToText[this.selectedOptions[1]]).then(res => {
					console.log('结果', res)
					if (res.message === 'query ok') {
						this.loading = false
						this.nearAddressArr = res.data
					} else {
						this.loading = false
						this.$toast.stMessage(res.message)
					}
				})
			},
			
			editCompany(row) {
				console.log(row)
				this.$confirm('是否确认操作该用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let data = {
						id:null,
						valid:null
								}
					if(row.valid == 1){
						data.valid = 0;
						data.id = row.id
					}else if(row.valid == 0){
						data.valid = 1;
						data.id = row.id
					}
					this.$server.system.deleteUser(data,(res) => {
						console.log(res)
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						this.searchList()
					})
				})
			},

			addUser() {
				this.editData = {
					genre: 'SYSTEM',
					name:'',
					logisticsUser:{
						name:'',
						account:'',
						password:'',
					},
					
				}
				this.dialogTitle = '新增账号'
				this.toggleStDialog = true
			},

			resetEditData() {
				this.editData = {
					genre: 'SYSTEM'
				}
				this.selectedOptions = []
			},

			handleChange(value) {
				// 省市区选择
				const [provinceName, cityName, areaName] = [CodeToText[value[0]], CodeToText[value[1]], CodeToText[value[2]]]
				this.editData.provinceName = provinceName
				this.editData.cityName = cityName
				this.editData.areaName = areaName
				this.editData.provinceCode = value[0]
				this.editData.cityCode = value[1]
				this.editData.areaCode = value[2]
			},

			selectionChange(val) {
				this.selectedList = val;
				console.log(this.selectedList)
			},

			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.loading=true;
				this.getData(orderForm)
			},
			
			getRoleList() {
				this.$server.role.getRole({
					current: 1,
					size: 999
				}, res => {
					console.log(res)
					this.roleTypeList = res.data.records
				})
			},

			getData(data) {
				this.$server.system.queryjoinlogistics(data, (res) => {
					this.loading=false;
					if (res.code == 0) {
						this.dataList = res.data.records;

						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if (res.data.total > 0) {
							this.togglePage = true;
						}
					}
				})
			},

			getRoldId(id) {
				return new Promise((resolve, reject) => {
					this.$server.role.getUser(id, res => {
						const roleId = res.data.roleList.map(item => {
							return item.id
						})
						resolve(roleId)
					})
				})
			},
//编辑
			async editUser(row) {
				console.log(row)
				this.dialogTitle = '编辑账号'
				// const roleId = await this.getRoldId(row.id)
				this.$nextTick(() => {
					this.editData = JSON.parse(JSON.stringify(row))
					this.editData.logisticsUser = {
						name:'',
						account:'',
						password:'',
					}
					// this.$set(this.editData,"roleId", roleId)
					this.selectedOptions = [row.provinceCode, row.cityCode, row.areaCode]
					this.toggleStDialog = true;
				})
				
			},
//充值
		async Recharge(row) {
			console.log(row)
				this.dialogTitle = '余额充值'
				// const roleId = await this.getRoldId(row.id)
				let JSONData = JSON.parse(JSON.stringify(row))
				this.$nextTick(() => {
					
					this.amountData = {
						  amount:this.amountData.amount,
						  companyId: JSONData.id
					}
			
					this.toggleStDialog2 = true;
				})
				
			},
			
			checkData() {
			if (!this.editData.id) {
			for (let i in this.normalCheck) {
				if (!this.editData.logisticsUser[i]) {
					this.$toast.stMessage(this.normalCheck[i], false)
					return false
				}
			}	
			}
				if (this.editData.genre == 'FRANCHISE') {
					for (let i in this.franshiseCheck) {
						if (!this.editData[i]) {
							this.$toast.stMessage(this.franshiseCheck[i], false)
							return false
						}
					}
				}

				return true
			},
			checkamountData() {
			if (!this.amountData.id) {
			for (let i in this.amountCheck) {
				if (!this.amountData[i]) {
					this.$toast.stMessage(this.amountCheck[i], false)
					return false
				}
			}	
			}
				if (this.editData.genre == 'FRANCHISE') {
					for (let i in this.franshiseCheck) {
						if (!this.editData[i]) {
							this.$toast.stMessage(this.franshiseCheck[i], false)
							return false
						}
					}
				}
			
				return true
			},
			
		async saveDialogForm2() {
			console.log(this.amountData)
				if (!this.checkamountData()) return
				let data = Object.assign({}, this.amountData);
				this.$server.system.recharge(data, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`充值成功`, true)
						this.toggleStDialog2 = false;
						this.searchList()
					} else {
						this.$toast.stMessage(res.message, false)
					}
				})
				},
				
				
			async saveDialogForm() {
				if (!this.checkData()) return
				// this.editData.logisticsUser.password = this.$md5(this.editData.logisticsUser.password) 
				let data = Object.assign({}, this.editData);
				let newData=JSON.parse(JSON.stringify(data));
				newData.logisticsUser.password = this.$md5(this.editData.logisticsUser.password);
				let sendMethod = 'updatejoinlogistics'
				console.log(newData)
				if (!this.editData.id) {
					sendMethod = 'createjoinlogistics'
				}
				this.$server.system[sendMethod](newData, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
						this.toggleStDialog = false;
						this.searchList()
					} else {
						this.$toast.stMessage(res.message, false)
						
					}
				})
			},
			closeDialogForm(){
				this.toggleStDialog=false;
				this.toggleStDialog2=false;
			},
			changeStatus(row) {
				this.$server.system.switchUserState(row.id, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
					} else {
						this.$toast.stMessage(res.message, false)
						this.resetEditData()
						this.searchList()
					}
				})
			},
		},
		mounted() {
			this.getRoleList()
		}
	}

</script>
<style>
	.st-main-content .el-input__icon {
		line-height: normal;
	}

	.st-main-content .ssq {
		width: 250px;
		height: 31px;
		line-height: normal;
	}

	.st-main-content .ssq .el-input__inner {
		width: 250px;
	}
</style>

<style scoped>
	.require-desc {
		color: red;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		width: 720px;
	}

	.st-dialog-form li {
		margin-right: 20px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.account-manage {
		width: 100%;
		height: auto;
	}

	.setRole {
		display: inline-block;
		width: 95px;
		height: 32px;
		line-height: 32px;
		color: #32BB57;
		cursor: pointer;
		margin: 0;

	}

	.st-order-btns {
		display: flex;
		justify-content: space-around;
	}

	.st-order-btns span {
		width: 80px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		border-radius: 2px;
		cursor: pointer;
		margin-left: 8px;
	}

	.stStgz {
		background-color: #FF5B3E;
	}

	.stMbgc {
		background-color: #32BB57;
	}

	/* 弹窗内 */
	/*  */
	.st-dialog-content {
		/* min-height: 200px; */
		padding: 0 32px;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.st-dialog-form li {
		width: 156px;
		padding: 13px 0;
	}

	.st-dialog-form li:nth-child(even) {
		float: right;
	}

	.st-dialog-form li:nth-child(odd) {
		float: left;
	}

	.st-dialog-form .st-dialog-item-title {
		height: 20px;
		line-height: 20px;
	}

	.st-dialog-form .st-dialog-item-title i {
		color: #FF5B3E;
	}

	.st-dialog-form .st-dialog-item-input input {
		width: 156px;
		height: 30px;
		text-indent: 8px;
		border-radius: 2px;
		border: 1px solid #DCDCDC;
		box-sizing: border-box;
	}

	.setConfig {
		cursor: pointer;
	}

	/* end */
</style>